/* global gsap */

class AnimateRow {
  constructor({element}) {
    this.wrapper = element;
    const target = element.querySelector('[data-ref="scrolling-helmets-grid"]');
    const clone = target.cloneNode(true);
    clone.setAttribute('aria-hidden', true);
    target.after(clone);

    this.createTimeline();
  }

  createTimeline() {
    const grid = this.wrapper.querySelectorAll('[data-ref="scrolling-helmets-grid"]');

    this.tl = gsap.to(grid, {
      scrollTrigger: {
        trigger: '[data-ref="scrolling-helmets-trigger"]',
        scrub: 3,
        start: 'top bottom',
        end: 'bottom top',
      },
      xPercent: -90,
    });
  }
}

const heroGrid = document.querySelectorAll('[data-ref="scrolling-helmets-grid-wrap"]');

heroGrid.forEach((element) => {
  new AnimateRow({
    element,
  });
});
